import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { getServerSession } from 'next-auth'
import { signIn } from 'next-auth/react'
import React from 'react'

import { Logo } from '@/components/common/Logo'
import { Button } from '@/components/ui/button'

import { authOptions } from '@/pages/api/auth/[...nextauth]'

import type { GetServerSidePropsContext } from 'next'

export default function Login() {
  const { replace } = useRouter()

  const { mutate: signInMutation, isPending } = useMutation({
    mutationFn: () => signIn('zitadel'),
    onError: error => {
      console.error(error)
    },
    onSuccess: result => {
      if (result?.error) {
        console.error(result?.error)
      }
      replace('/')
    }
  })

  return (
    <div
      className={
        'min-h-svh p-8 flex items-center justify-center bg-gradient-to-r from-primary-magenta to-primary-purple'
      }
    >
      <div
        className={
          'max-w-md w-full flex flex-col items-center justify-center py-6 px-8 gap-8 rounded-lg shadow-md bg-white'
        }
      >
        <div className={'w-20 h-24 relative text-primary-purple'}>
          <Logo />
        </div>
        <h2 className={'text-2xl font-bold'}>Accedi al Backoffice</h2>
        <Button
          variant='dark'
          className={'w-full py-6'}
          onClick={() => signInMutation()}
          disabled={isPending}
        >
          Accedi tramite SSO
        </Button>
      </div>
    </div>
  )
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const session = await getServerSession(context.req, context.res, authOptions)

  if (session) {
    return {
      redirect: {
        destination: '/',
        permanent: false
      }
    }
  }

  return {
    props: {}
  }
}
